// Preference axis mapping.
// UI vibe axes (0-100) map 1-to-1 to API Preferences (0-10).
// Divide by 10 going to the API; multiply by 10 coming back.

export function vibeToApiPrefs(vibe) {
  return {
    physical:  Math.round((vibe.physical  ?? 50) / 10),
    social:    Math.round((vibe.social    ?? 50) / 10),
    outdoor:   Math.round((vibe.outdoor   ?? 50) / 10),
    newPeople: Math.round((vibe.newPeople ?? 50) / 10),
    creative:  Math.round((vibe.creative  ?? 50) / 10),
    boozy:     Math.round((vibe.boozy     ?? 20) / 10),
    eating:    Math.round((vibe.eating    ?? 50) / 10),
    expensive: Math.round((vibe.expensive ?? 30) / 10),
    nsfw:      Math.round((vibe.nsfw      ??  0) / 10),
    fun:       5,
  };
}

export function apiPrefsToVibe(p) {
  return {
    physical:  (p.physical  ?? 5) * 10,
    social:    (p.social    ?? 5) * 10,
    outdoor:   (p.outdoor   ?? 5) * 10,
    newPeople: (p.newPeople ?? 5) * 10,
    creative:  (p.creative  ?? 5) * 10,
    boozy:     (p.boozy     ?? 2) * 10,
    eating:    (p.eating    ?? 5) * 10,
    expensive: (p.expensive ?? 3) * 10,
    nsfw:      (p.nsfw      ?? 0) * 10,
    fun:       (p.fun       ?? 7) * 10,
  };
}
